import { pick, isEqual } from 'lodash';
import { get, post, patch } from '@/helpers/httpHandler';
import scheduleFilters from '../common/schedule-filters';
import errors from '@/modules/_global/mixins/errors';

export default {
  getTasks({ commit }, { params } = {}) {
    return get(`/planning/tasks`, params).then(response => {
      commit('setTasks', response.data.data);

      return response;
    });
  },

  getTasksDate({ commit }, { params } = {}) {
    return get(`/planning/tasks-date`, params).then(response => {
      commit('setTasksDate', response.data.data);

      return response;
    });
  },

  getOrdersList({ commit }, { params } = {}) {
    return get(`/planning/filters/orders`, params).then(response => {
      commit('setOrdersList', response.data.data);

      return response;
    });
  },

  getEmployeesList(_, { params } = {}) {
    params = pick(params, [
      scheduleFilters.SERVICES,
      scheduleFilters.BUILDING_COMPLEXES,
      scheduleFilters.REGIONS,
      scheduleFilters.SKILLS
    ]);

    return get(`/planning/filters/employees`, params);
  },

  setEmployeesList({ commit }, { employees }) {
    commit('setEmployeesList', employees);
  },

  getServicesList({ commit }, { params } = {}) {
    return get(`/employee-services`, params).then(response => {
      commit('setServicesList', response.data.data);

      return response;
    });
  },

  getReasonsList: ({ commit }, { params } = {}) => {
    return get(`/planning/block/reasons`, params).then(response => {
      commit('setReasonsList', response.data.data);

      return response;
    });
  },

  getReiterationsList: ({ commit }) => {
    return get('/planning/event/reiterations').then(response => {
      commit('setReiterationsList', response.data.data);

      return response;
    });
  },

  getBlockTask: ({ commit }, { taskId, params } = {}) => {
    return get(`/planning/block/${taskId}`, params).then(response => {
      commit('updateTask', response.data);
      commit('setCurrentTask', response.data);

      return response;
    });
  },

  storeBlockTask: ({ commit }, { task }) => {
    return post(`/planning/block`, task).then(response => {
      const tasks = response.data.data || [];

      tasks.forEach(task => {
        commit('addTask', task);
      });

      return response;
    });
  },

  updateBlockTask: ({ commit }, { taskId, task }) => {
    return patch(`/planning/block/${taskId}`, task).then(response => {
      commit('updateTask', response.data);

      return response;
    });
  },

  destroyBlockTask: ({ commit }, { taskId, question }) => {
    return post(`/planning/block/${taskId}`, { question }).then(response => {
      const removedTaskIds = response.data.ids || [];
      commit('removeTasks', removedTaskIds);

      return response;
    });
  },

  getTaskStatuses({ commit }, { params } = {}) {
    return get(`/planning/event/statuses`, params).then(response => {
      commit('setTaskStatuses', response.data.data);

      return response;
    });
  },

  checkHoliday({ commit }, { id, ...params } = {}) {
    return get(`/planning/event/${id}/check-holiday`, params).then(response => {
      return response;
    });
  },

  getTask: ({ commit }, { taskId, params } = {}) => {
    return get(`/planning/event/${taskId}`, params).then(response => {
      commit('updateTask', response.data);
      commit('setCurrentTask', response.data);

      return response;
    });
  },

  storeTask: ({ commit }, { task }) => {
    return post(`/planning/event`, task).then(response => {
      const addedTasks = response.data.data || [];

      commit('addTasks', addedTasks);

      return response;
    });
  },

  updateTask: ({ commit }, { taskId, task }) => {
    return patch(`/planning/event/${taskId}`, task).then(response => {
      const errors = response.data.errors;

      if (errors && errors.length) {
        errors.forEach(item => {
          commit('addSnacks', {
            color: 'orange accent-2',
            type: 'warning',
            timeout: 3600000,
            message: item
          });
        });
      }
      return response;
    });
  },

  destroyTask: ({ commit }, { taskId, question }) => {
    return post(`/planning/event/${taskId}`, { question }).then(response => {
      const removedTaskIds = response.data.ids || [];

      commit('removeTasks', removedTaskIds);

      return response;
    });
  },

  setDay: ({ commit }, day) => {
    commit('setDay', day);
  },

  setOrder: ({ commit }, order) => {
    commit('setOrder', order);
  },

  setDayEntity: ({ commit }, { day, entity }) => {
    commit('setSelectedDay', day);
    commit('setSelectedEntity', entity);
  },

  setScheduleFilters: ({ commit, state }, filters) => {
    const filterParams = pick(filters, Object.values(scheduleFilters));

    if (isEqual(state.filters, filterParams)) {
      return;
    }

    commit('setScheduleFilters', filterParams);
  },

  addSnack: ({ commit }, snack) => {
    commit('addSnacks', snack);
  },

  setSnacks: ({ commit }, snacks) => {
    commit('setSnacks', snacks);
  },

  clearSnacks: ({ commit }) => {
    commit('clearSnacks');
  },

  setIsMultiTaskUpdate: ({ commit }) => {
    commit('setIsMultiTaskUpdate');
  },

  getEmployeesRequestedVacations: ({ commit }, { params } = {}) => {
    return get(`/planning/request-vacations`, params).then(response => {
      commit('setEmployeesRequestedVacations', response.data.data);

      return response;
    });
  }
};
